import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api, { tneAxiosClient } from '../api/apiSettings';
import { removeDuplicates } from '../utils/helpers';

export const types = {
  ...addAsyncActionPostfixes({
    GET_CONSTATNTS: 'GET_CONSTATNTS',
    GET_PLACEMENTS_CONSTANTS: 'GET_PLACEMENTs_CONSTANTS'
  })
};

export const getConstants = createAsyncAction(types.GET_CONSTATNTS, (isTNE = false) => {
  return Promise.allSettled([
    api.get(`v1/job-functions`),
    api.get(`v1/industries`),
    api.get(`v1/contract-types`),
    api.get(`v1/job-periods`),
    api.get(`v1/currencies`),
    isTNE ? tneAxiosClient.get('v1/clients') : Promise.resolve({ data: { Data: [] } }),
    isTNE ? tneAxiosClient.get('v1/worktypes') : Promise.resolve({ data: { Data: [] } }),
    isTNE ? tneAxiosClient.get('v1/expense-types') : Promise.resolve({ data: { Data: [] } })
  ])
    .then((result) => ({
      functionsDirections: result[0]?.value?.data.Data || [],
      industries: result[1]?.value?.data.Data || [],
      contractTypes: result[2]?.value?.data.Data || [],
      filterPeriods: result[3]?.value?.data.Data || [],
      currencies: result[4]?.value?.data.Data || [],
      clients: removeDuplicates(result[5]?.value?.data.Data || []),
      worktypes: result[6]?.value?.data.Data || [],
      expensetypes: result[7]?.value?.data.Data || []
    }))
    .catch((err) => {
      throw err;
    });
});

export const getPlacements = createAsyncAction(types.GET_PLACEMENTS_CONSTANTS, (id) => {
  return tneAxiosClient.get(`v1/placement/${id}`).then((res) => ({ placements: res.data.Data }));
});
